import { useObjectDatesMapper } from './dateHelper';
import { AbstractTask } from '../Types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export function useTasksResponseMapper() {
  const {
    mapSingle: mapSingleBase,
  } = useObjectDatesMapper<AbstractTask>(
    [
      'dueDate.date',
      '_approximateDueDate',
    ],
    [
      'completedAt',
    ],
  );

  const mapSingle = (source: Record<string, any>): AbstractTask => {
    const mapped = mapSingleBase(source);

    if (mapped.dueDate?.time && mapped.dueDate?.timezone) {
      // Parse the datetime string in the specified timezone
      // Format: "YYYY-MM-DD HH:mm:ss"
      mapped.dueDate.time = dayjs.tz(
        String(mapped.dueDate.time),
        'YYYY-MM-DD HH:mm:ss',
        mapped.dueDate.timezone
      ).toDate();
    }

    if (mapped.dueDate?.endTime && mapped.dueDate?.timezone) {
      // Parse the datetime string in the specified timezone
      // Format: "YYYY-MM-DD HH:mm:ss"
      mapped.dueDate.endTime = dayjs.tz(
        String(mapped.dueDate.endTime),
        'YYYY-MM-DD HH:mm:ss',
        mapped.dueDate.timezone
      ).toDate();
    }

    return mapped;
  }

  const mapList = (source: Record<string, any>[]): AbstractTask[] => {
    return source.map(mapSingle);
  }


  return {
    mapSingle,
    mapList,
  };
}
